export default __webpack_public_path__ + "static/hola-7613b944c5d59ab153640b2f78e561a7.png";